import { useSuspenseQuery } from '@tanstack/react-query'

import { GetSimulacoesPorIds } from '@/features/proposta/shared/http/get-simulacoes-por-ids.service'
import { propostaSharedKeys } from '@/features/proposta/shared/utils/queries'
export const useSuspenseSimulacoesPorIds = (simulacoesIds: string[]) => {
  return useSuspenseQuery({
    queryKey: propostaSharedKeys.listaSimulacoesLancadas(simulacoesIds),
    queryFn: async () => new GetSimulacoesPorIds().execute(simulacoesIds).then((res) => res.data),
  })
}
